<template>
  <div>
    <div v-if="showTransactionFee"  class="flex justify-between">
      <div class="flex justify-start" :class="isCheckPage ? 'text-[14px]' : 'text-[16px]'">
        <div class="text">{{ $t("OrderPage[\"(Transaction Fee)\"]") }}</div>
        <el-tooltip  :content="'Click for transaction fee info'">
          <div @click="isShowTransactionFeeDialog = true">
            <span class="material-icons-outlined" :class="isCheckPage ? 'info-icon-checkout' : 'info-icon'">
              info
            </span>
          </div>
        </el-tooltip>
      </div>
      <div class="text">--</div>
    </div>
    <AddOwnFee v-if="!isCheckPage" :count="count"/>
    <TransactionFeeDialog 
      :is-show-dialog="isShowTransactionFeeDialog"
      @close="isShowTransactionFeeDialog = false"
    />
  </div>
</template>

<script>
import AddOwnFee from './AddOwnFee.vue';
import TransactionFeeDialog from './TransactionFeeDialog.vue';
import { mapState } from "vuex";

export default {
  components: {
    AddOwnFee,
    TransactionFeeDialog,
  },

  props: {
    count: {
      type: Number,
      default: 0,
    },
    haveMarkup: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      isShowTransactionFeeDialog: false,
    };
  },  

  computed: {
    ...mapState("orderTest/order", ["consultationFee"]),

    showTransactionFee() {
      return this.consultationFee.isUse || this.haveMarkup;
    },

    isCheckPage() {
      return window.location.href.includes("/checkout")
    }
  }
}
</script>

<style scoped>
.text {
  font-family: Roboto;
  font-weight: 500;
  line-height: 18.75px;
  letter-spacing: 0.45px;
  text-align: left;
  color: #979797;
}

.info-icon {
  margin-left: 3.5px;
  cursor: pointer;
  font-size: 16px;
}

.info-icon-checkout {
  margin-left: 3.5px;
  margin-top: 2px;
  cursor: pointer;
  font-size: 14px;
}
</style>